angular.module('forms').factory('FormsRepository',
    ['AprimaRestangular', function (AprimaRestangular) {
        'use strict';

        function getAssignedQuestionnaires(userId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/questionnaires-assigned').get();
        }

        function getQuestionnaireDetails(userId, relSurveyPatientId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/questionnaire-view-details/' + relSurveyPatientId).get();
        }

        function getPatientQuestionnaire(userId, relSurveyPatientId) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId + '/questionnaire/' + relSurveyPatientId).get();
        }

        function putPatientQuestionnaire(patientQuestionnaireDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular
                .one('patients/' + patientQuestionnaireDto.PatientId + '/questionnaire/' + patientQuestionnaireDto.RelSurveyPatientId)
                .customPUT(patientQuestionnaireDto);
        }

        function getAssignedPracticeForms(userId, searchCriteriaDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular.one('patients/' + userId).customGET('forms', searchCriteriaDto);
        }


        function getPracticeFormAttachment(patientId, attachmentId, relPracticeFormPatientId) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?relPracticeFormPatientId=' + relPracticeFormPatientId;
            return restangular.one('patients/' + patientId + '/forms-attachment/' + attachmentId + queryString).get();
        }


        function getPracticeFormImage(patientId, attachmentId, relPracticeFormPatientId, requestSettings) {
            var restangular = AprimaRestangular.get('patient');
            var queryString = '?relPracticeFormPatientId=' + relPracticeFormPatientId + '&height=' + requestSettings.height + '&width=' + requestSettings.width + '&page=' + requestSettings.page;
            return restangular.one('patients/' + patientId + '/forms-attachment/' + attachmentId + queryString).get();
        }

        // [Route("api/patient/v1/patients/{patientId:guid}/forms-attachment/{attachmentId:guid}/update-download-date"/)]
        function updatePracticeFormDownloadDate(patientId, attachmentId, updateDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular
                .one('patients/' + patientId + '/forms-attachment/' + attachmentId + '/update-download-date')
                .customPUT(updateDto);
        }

        //[Route("api/patient/v1/patients/{patientId:guid}/forms-attachment/{attachmentId:guid}/update-upload-date")]
        function updatePracticeFormUploadDate(patientId, attachmentId, updateDto) {
            var restangular = AprimaRestangular.get('patient');
            return restangular
                .one('patients/' + patientId + '/forms-attachment/' + attachmentId + '/update-upload-date')
                .customPUT(updateDto);
        }


        //[Route("api/patient/v1/patients/{patientId:guid}/forms-attachment/{attachmentId:guid}/create-approval")]
        function createApprovalMessage(patientId, model) {
            var restangular = AprimaRestangular.get('patient');
            return restangular
                .one('patients/' + patientId + '/forms-attachment/create-approval')
                .customPOST(model);
        }


        return {
            getAssignedQuestionnaires: getAssignedQuestionnaires,
            getPatientQuestionnaire: getPatientQuestionnaire,
            getQuestionnaireDetails: getQuestionnaireDetails,
            putPatientQuestionnaire: putPatientQuestionnaire,
            getAssignedPracticeForms: getAssignedPracticeForms,
            getPracticeFormAttachment: getPracticeFormAttachment,
            updatePracticeFormDownloadDate: updatePracticeFormDownloadDate,
            updatePracticeFormUploadDate: updatePracticeFormUploadDate,
            getPracticeFormImage: getPracticeFormImage,
            createApprovalMessage : createApprovalMessage
        };

    }]);